import { render } from "./LoadIFrame.vue?vue&type=template&id=35e4d15a&scoped=true"
import script from "./LoadIFrame.vue?vue&type=script&lang=js"
export * from "./LoadIFrame.vue?vue&type=script&lang=js"

import "./LoadIFrame.vue?vue&type=style&index=0&id=35e4d15a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e4d15a"]])

export default __exports__